import moment from "moment-jalaali";
import _, { isEqual } from "lodash";
import { FormattedMessage } from "react-intl";
import React, { lazy, Fragment } from "react";
import {
    boxGeneratorComponentProps,
    notPostSearchList,
    APIPathsOfPlatform,
    imagesStaticUrl,
    categorySubCategory,
    root,
} from "./GlobalVariables";
import UserAccess from "./shared/permission/UserAccess";
import { img_planing_warning } from "ui-components/ui-images";

/**
 * تبدیل تاریخ میلادی به جلالی
 * @param {*} value تاریخ میلادی
 * @param {*} jalaliFormat فرمت تاریخ شمسی
 * @param {*} originalFormat فرمت  تاریخ میلادی
 */
export const getJalaliDate = (value, jalaliFormat = "jYYYY/jMM/jDD HH:mm", originalFormat = "YYYY-M-D HH:mm:ss") => {
    return !_.isEmpty(value) ? moment(value, originalFormat).format(jalaliFormat).toString() : "";
};

//زمان فعلی رو بر میگردونه که شامل تاریخ و زمان هست
//پارامتر ago به تعداد از امروز کم میکنه
export const getDateTime = (d_ago, h_ago) => {
    const now = new Date();

    const hoursAgo = h_ago ? h_ago : 0;
    now.setHours(now.getHours() - hoursAgo);

    const daysAgo = d_ago ? d_ago : 0;
    now.setDate(now.getDate() - daysAgo);

    const year = now.getFullYear();
    let month = now.getMonth() + 1;
    let day = now.getDate();
    let hour = now.getHours();
    let minute = now.getMinutes();
    let second = now.getSeconds();
    if (month.toString().length === 1) {
        month = "0" + month;
    }
    if (day.toString().length === 1) {
        day = "0" + day;
    }
    if (hour.toString().length === 1) {
        hour = "0" + hour;
    }
    if (minute.toString().length === 1) {
        minute = "0" + minute;
    }
    if (second.toString().length === 1) {
        second = "0" + second;
    }

    return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
};

// تبدیل هشتگ‌های درون متن به لینک
export const extractHashtags = (str) => {
    return typeof str === "undefined" ? "" : str.replace(/#[^#\s]+/g, ' <span data-val="/$&">$&</span> ');
};

// افزودن تارگت برای تگ لینک درون متن
export const changeTarget = (str) => {
    return str.split("<a").join('<a target="_blank"');
};

// گرد کردن اعداد و تبدیل به میلیون هزار و... براساس عدد
export const roundNumber = (num) => {
    // if (!num || _.isEmpty(num) || num === 0) return num;
    num = parseInt(num);
    if (num > 999999) return (num / 1000000).toFixed(1) + " M";
    if (num > 9999) return (num / 1000).toFixed(1) + " K";
    if (num > 999) return (num / 1000).toFixed(1) + " K";
    if (num > 10 && num < 1000 && !_.isInteger(num)) return num.toFixed(1);
    if (num > 1 && num < 10 && !_.isInteger(num)) return num.toFixed(1);
    if (num < 1 && num != 0) return num.toFixed(1);
    return numberWithCommas(num);
};

export const convertDigitToCommaSeperatedString = (digit) => {
    if (!digit || digit === 0) return 0;
    return digit?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

//تبدیل اعداد فارسی به انگلیسی در یک رشته
export const convertDigitToEnglish = (str) => {
    return str
        .replace(/[\u0660-\u0669]/g, function (c) {
            return c.charCodeAt(0) - 0x0660;
        })
        .replace(/[\u06f0-\u06f9]/g, function (c) {
            return c.charCodeAt(0) - 0x06f0;
        });
};

export const getPlatformByAPI = (api, platforms) => {
    let targetPlatform = "";

    //es2017
    Object.entries(platforms).forEach(([platform, APIs]) => {
        if (Object.keys(APIs).indexOf(api) > -1) {
            targetPlatform = platform;
            return false;
        }
    });

    return targetPlatform;
};

export const trimData = (dataArray) => {
    const SCRIPT_REGEX = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
    const HEAD_REGEX = /<head\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/head>/gi;

    return dataArray.map((item) => {
        let text = item.description;
        while (SCRIPT_REGEX.test(text)) {
            text = text.replace(SCRIPT_REGEX, "");
        }
        while (HEAD_REGEX.test(text)) {
            text = text.replace(HEAD_REGEX, "");
        }

        return {
            ...item,
            description: text,
        };
    });
};

const BoxWrapper = lazy(() => import("shared/Box/BoxWrapper"));

const WordCloud = lazy(() => import("shared/chart/WordCloud/WordCloud"));

const MiniBox = lazy(() => import("shared/miniBox/MiniBox"));

const MiniBoxList = lazy(() => import("shared/miniBox/MbList"));

const MbTimeLine = lazy(() => import("shared/miniBox/mbRelease/MbRelease"));

const Dashboard = lazy(() => import("shared/chart/Dashborad/DashboardMultiColor/DashboardMultiColor"));

const MiniBoxTag = lazy(() => import("shared/miniBox/mbTags/MbTags"));

const MiniBoxHashtag = lazy(() => import("shared/miniBox/mb-hashtag/MbHashtag"));

const MiniBoxLink = lazy(() => import("shared/miniBox/mb-link/MbLink"));

const MiniBoxStats = lazy(() => import("shared/miniBox/mb-stats/MiniBoxStats"));

const MiniBoxTab = lazy(() => import("shared/miniBox/mb-tab/MbTab"));

const Histogram = lazy(() => import("shared/chart/Histogram/CustomHistogram/CustomHistogram"));

const DonutChart = lazy(() => import("shared/chart/DonutChart/DonutChart"));

const LargeScaleAreaMap = lazy(() => import("shared/chart/largeScaleArea/LargeScaleAreaMap"));

const AreaMap = lazy(() => import("shared/chart/AreaMap/AreaMap"));

const KioskBox = lazy(() => import("shared/kiosk/kioskBox"));

const liveBox = lazy(() => import("shared/Box/liveBox"));

const LineChart = lazy(() => import("shared/chart/line-chart/LineChart"));

const polarChart = lazy(() => import("shared/chart/polar/PolarChart"));

const WordCluster = lazy(() => import("shared/chart/word-cluster/WordCluster"));

const ContentBoxWrapper = lazy(() => import("shared/contentBox/BoxWrapper"));

const MultiLevelDonut = lazy(() => import("shared/multi-level-donut/MultiLevelDonut"));

//const AreaMap = lazy(() => import('shared/chart/AreaChart/GrandientAreaMap/GrandientAreaMap'));

/**
 * get Box type info by key
 * --------Boxes Types--------
 * box
 * miniBox
 * donutChart
 * barChart ====
 * lineChart ====
 * cloud
 * areaChart ====
 * gage
 * histogram
 * polar ====
 * waterWave ====
 * miniBoxCounter ====
 * @param keys : array or string
 * @param intl : object
 * @param applyAccess : boolean
 */
/*این فانکشن همه ی نوع باکس تایپ ها را بر میگرداند*/
export const getBoxesTypes = (keys, intl, applyAccess = true) => {
    if (!_.isString(keys) && !_.isArray(keys)) {
        return [];
    }

    const { formatMessage } = intl;

    const boxTypes = [
        {
            id: "box",
            label: formatMessage({ id: "boxes.table" }),
            component: BoxWrapper,
            icon: "icon icon-table",
        },
        {
            id: "miniBox",
            label: formatMessage({ id: "boxes.mini_box" }),
            component: MiniBox,
            icon: "icon icon-box-list",
        },
        {
            id: "largeScaleAreaMap",
            label: formatMessage({ id: "boxes.large_scale_area_chart" }),
            component: LargeScaleAreaMap,
            icon: "icon icon-line-state",
        },
        {
            id: "areaMap",
            label: formatMessage({ id: "boxes.area_map" }),
            component: AreaMap,
            icon: "icon icon-line-state",
        },
        {
            id: "donutChart",
            label: formatMessage({ id: "boxes.donut_chart" }),
            component: DonutChart,
            icon: "icon icon-percentage",
        },
        {
            id: "cloud",
            label: formatMessage({ id: "boxes.cloud" }),
            component: WordCloud,
            icon: "icon icon-diagram",
        },
        {
            id: "gage",
            label: formatMessage({ id: "boxes.gage" }),
            component: Dashboard,
            icon: "icon icon-gauge",
        },
        {
            id: "histogram",
            label: formatMessage({ id: "boxes.histogram" }),
            component: Histogram,
            icon: "icon icon-bar-chart",
        },
        {
            id: "miniBoxList",
            label: formatMessage({ id: "boxes.mini_box_List" }),
            component: MiniBoxList,
            icon: "icon icon-box-list",
        },
        {
            id: "miniBoxTimeLine",
            label: formatMessage({ id: "boxes.mini_box_Release" }),
            component: MbTimeLine,
            icon: "icon icon-box-list",
        },
        {
            id: "miniBoxTag",
            label: formatMessage({ id: "boxes.mini_box_Tags" }),
            component: MiniBoxTag,
            icon: "icon icon-box-list",
        },
        {
            id: "miniBoxHashtag",
            label: formatMessage({ id: "boxes.mini_box_Hashtag" }),
            component: MiniBoxHashtag,
            icon: "icon icon-tag",
        },
        {
            id: "miniBoxLink",
            label: formatMessage({ id: "boxes.mini_box_Hashtag" }),
            component: MiniBoxLink,
            icon: "icon icon-tag",
        },
        {
            id: "miniBoxStats",
            label: formatMessage({ id: "boxes.mini_box_stats" }),
            component: MiniBoxStats,
            icon: "icon icon-box-list-full",
        },
        {
            id: "miniBoxTab",
            label: formatMessage({ id: "boxes.mini_box_Tab" }),
            component: MiniBoxTab,
            icon: "icon icon-tag",
        },
        {
            id: "contentBox",
            label: formatMessage({ id: "boxes.content_box" }),
            component: ContentBoxWrapper,
            icon: "icon icon-news-post",
        },
        {
            id: "kioskBox",
            label: formatMessage({ id: "boxes.kiosk_box" }),
            component: KioskBox,
            icon: "icon icon-news-post",
        },
        {
            id: "liveBox",
            label: formatMessage({ id: "boxes.live_box" }),
            component: liveBox,
            icon: "icon icon-news-post",
        },
        {
            id: "lineChart",
            label: formatMessage({ id: "boxes.line_chart" }),
            component: LineChart,
            icon: "icon icon-line-state",
        },
        {
            id: "polarChart",
            label: formatMessage({ id: "boxes.polar_chart" }),
            component: polarChart,
            icon: "icon icon-diagram",
        },
        {
            id: "wordCluster",
            label: formatMessage({ id: "boxes.word_cluster" }),
            component: WordCluster,
            icon: "icon icon-diagram",
        },
        {
            id: "multiLevelDonut",
            label: formatMessage({ id: "boxes.word_cluster" }),
            component: MultiLevelDonut,
            icon: "icon icon-diagram",
        },
        //add after completing
        /*{
			id: "lineChart",
			label: formatMessage({ id: 'boxes.line_chart' }),
			component: "LineChart"
		},
		{
			id: "waterWave",
			label: formatMessage({ id: 'boxes.water_wave' }),
			component: WaterWave
		},*/
        //TODO: added a polar on future
        /*{
			id: "polar",
			label: formatMessage({ id: 'boxes.polar' }),
			component: Polar
		},*/
        /*{
			id: "barChart",
			label: formatMessage({ id: 'boxes.bar_chart' }),
			component: "BarChart"
		},*/
        /*{
			id: "areaChart",
			label: formatMessage({ id: 'boxes.area_chart' }),
			component: AreaMap
		},*/
        /*{
			id: "miniBoxCounter",
			label: formatMessage({ id: 'boxes.mini_box_counter' }),
			component: "MiniBoxCounter"
		},*/
        /*{
			id: "Dashboard",
			label: formatMessage({ id: 'boxes.mini_box_Release' }),
			component: Dashboard
		},*/
    ];

    if (keys === "all") {
        if (!applyAccess) {
            return boxTypes;
        } else {
            return boxTypes.filter((typeItem) => {
                return UserAccess.can(typeItem.id, "BoxTypes");
            });
        }
    }

    let newKeys = _.isString(keys) ? [keys] : keys;

    let finalBoxTypes;

    if (!applyAccess) {
        finalBoxTypes = boxTypes.filter((typeItem) => {
            return newKeys.indexOf(typeItem.id) > -1;
        });
    } else {
        finalBoxTypes = boxTypes.filter((typeItem) => {
            return newKeys.indexOf(typeItem.id) > -1 && UserAccess.can(typeItem.id, "BoxTypes");
        });
    }

    return _.isString(keys) ? finalBoxTypes[0] || {} : finalBoxTypes;
};

export const fixVarType = (type, value) => {
    let finalValue;

    switch (type.toLowerCase()) {
        case "string":
            finalValue = String(value);
            break;

        case "int":
            finalValue = parseInt(value) || 0;
            break;

        case "datetime":
            finalValue = String(value);
            break;

        case "float":
            finalValue = parseFloat(value) || 0;
            break;

        default:
            finalValue = value;
    }

    return finalValue;
};

export const wbFinalData = (props, item) => {
    let data = {};

    props.forEach(({ value, type }) => {
        let propVal = item && !_.isUndefined(item[value]) ? item[value] : "";

        data[value] = fixVarType(type, propVal);
    });

    return data;
};

/**
 * Validate data before send to components
 * @param type
 * @param displayData
 */
export const widgetBuilderValidateData = (type, displayData) => {
    if (_.isUndefined(boxGeneratorComponentProps[type])) {
        console.error(`Box type ${type} Not Exist`);
        return displayData;
    }

    let props = boxGeneratorComponentProps[type];

    let finalData = displayData;

    if (_.isArray(displayData)) {
        finalData = displayData.map((item) => {
            return wbFinalData(props, item);
        });
    } else if (_.isObjectLike(displayData)) {
        finalData = wbFinalData(props, displayData);
    }

    return finalData;
};

/*این فانکشن پلتفرم های موجود در اپ را بر میگرداند */
export const getPlatforms = (keys, intl, applyAccess = false) => {
    const { formatMessage } = intl;

    if (!_.isString(keys) && !_.isArray(keys)) {
        return [];
    }

    const platforms = [
        {
            id: "news",
            label: formatMessage({ id: "global.news" }),
            icon: "icon icon-news-post",
            path: "/news/posts",
            platform: "news",
            type: "post",
        },
        {
            id: "newsagenciesbysubject",
            label: formatMessage({ id: "global.newsagenciesbysubject" }),
            icon: "icon icon-news-post",
            path: "/news/agencies/by_subject",
            platform: "",
            type: "",
        },
        {
            id: "newsagencies",
            label: formatMessage({ id: "global.newsagencies" }),
            icon: "icon icon-news-group",
            path: "",
            platform: "news",
            type: "agency",
        },
        {
            id: "telegram",
            label: formatMessage({ id: "global.telegram" }),
            icon: "icon icon-telegram",
            path: "/telegram/posts",
            platform: "telegram",
            type: "post",
        },
        {
            id: "telegramcomments",
            label: formatMessage({ id: "global.telegramcomments" }),
            icon: "icon icon-telegram",
            path: "/telegram/comments",
            platform: "telegram",
            type: "comment",
        },
        {
            id: "telegramchannels",
            label: formatMessage({ id: "global.telegramchannels" }),
            icon: "icon icon-telegram-channel",
            path: "/telegram/channels",
            platform: "telegram",
            type: "channel",
        },
        {
            id: "telegramchannelsbysubject",
            label: formatMessage({ id: "global.telegramchannelsbysubject" }),
            icon: "icon icon-telegram-channel",
            path: "/telegram/channels/by_subject",
            platform: "",
            type: "",
        },
        {
            id: "telegramgroups",
            label: formatMessage({ id: "global.telegramgroups" }),
            icon: "icon icon-telegram-group",
            path: "/telegram/groups",
            platform: "telegram",
            type: "group",
        },
        {
            id: "telegramgroupsposts",
            label: formatMessage({ id: "global.telegramgroupsposts" }),
            icon: "icon  icon-telegram-group-post",
            path: "/telegram/groups/posts",
            platform: "telegram",
            type: "group_post",
        },
        {
            id: "telegramusers",
            label: formatMessage({ id: "global.telegramusers" }),
            icon: "icon icon-telegram-users",
            path: "/telegram/users",
            platform: "telegram",
            type: "user",
        },
        {
            id: "instagram",
            label: formatMessage({ id: "global.instagram" }),
            icon: "icon icon-instagram",
            path: "/instagram/posts",
            platform: "instagram",
            type: "post",
        },
        {
            id: "instagramcomments",
            label: formatMessage({ id: "global.instagramcomments" }),
            icon: "icon icon-instagram",
            path: "/instagram/comments",
            platform: "instagram",
            type: "comment",
        },
        {
            id: "instagramusers",
            label: formatMessage({ id: "global.instagramusers" }),
            icon: "icon icon-instagram-users",
            path: "/instagram/users",
            platform: "instagram",
            type: "user",
        },
        {
            id: "twitter",
            label: formatMessage({ id: "global.twitter" }),
            icon: "icon icon-twitter",
            path: "/twitter/posts",
            platform: "twitter",
            type: "post",
        },
        {
            id: "twitterusers",
            label: formatMessage({ id: "global.twitterusers" }),
            icon: "icon icon-twitter-users",
            path: "/twitter/users",
            platform: "twitter",
            type: "user",
        },
        {
            id: "facebook",
            label: formatMessage({ id: "global.facebook" }),
            icon: "icon icon-facebook",
            path: "/facebook/posts",
            platform: "facebook",
            type: "post",
        },
        {
            id: "facebookcomments",
            label: formatMessage({ id: "global.facebookcomments" }),
            icon: "icon icon-facebook-post",
            path: "",
            platform: "facebook",
            type: "comment",
        },
        {
            id: "facebookpages",
            label: formatMessage({ id: "global.facebookpages" }),
            icon: "icon icon-facebook-group",
            path: "/facebook/pages",
            platform: "facebook",
            type: "user",
        },
        {
            id: "facebookpagesbysubject",
            label: formatMessage({ id: "global.facebookpagesbysubject" }),
            icon: "icon icon-facebook-group",
            path: "/facebook/pages/by_subject",
            platform: "",
            type: "",
        },
        {
            id: "facebookusers",
            label: formatMessage({ id: "global.facebookusers" }),
            icon: "icon icon-facebook-users",
            path: "/facebook/users",
            platform: "facebook",
            type: "user",
        },
        {
            id: "facebookusersbysubject",
            label: formatMessage({ id: "global.facebookusersbysubject" }),
            icon: "icon icon-facebook-users",
            path: "/facebook/users/by_subject",
            platform: "",
            type: "",
        },
        {
            id: "facebookpostscomments",
            label: formatMessage({ id: "global.facebookpostscomments" }),
            icon: "icon icon-facebook-post",
            path: "/facebook/posts/comments",
            platform: "",
            type: "",
        },
        {
            id: "search_engine",
            label: formatMessage({ id: "global.search_engine" }),
            icon: "icon icon-search-result",
            path: "/search_engine/posts",
            platform: "search_engine",
            type: "post",
        },
        {
            id: "rrk",
            label: formatMessage({ id: "global.rrk" }),
            icon: "icon icon-line-state",
            path: "/rrk/posts",
            platform: "rrk",
            type: "post",
        },
        {
            id: "ketabavval",
            label: formatMessage({ id: "global.ketabavval" }),
            icon: "icon icon-ketab-aval-post",
            path: "/ketabavval/posts",
            platform: "ketabavval",
            type: "post",
        },
        {
            id: "dumper",
            label: formatMessage({ id: "global.dumper" }),
            icon: "icon icon-dumper-post",
            path: "/dumper/posts",
            platform: "dumper",
            type: "post",
        },
        {
            id: "blog",
            label: formatMessage({ id: "global.blog" }),
            icon: "icon icon-blog-post",
            path: "/blog/posts",
            platform: "blog",
            type: "post",
        },
        {
            id: "advertisement",
            label: formatMessage({ id: "global.advertisement" }),
            icon: "icon icon-advertisment",
            path: "/advertisement/posts",
            platform: "advertisement",
            type: "post",
        },
        {
            id: "dunro",
            label: formatMessage({ id: "global.dunro" }),
            icon: "icon icon-dunro-post",
            path: "/dunro/posts",
            platform: "dunro",
            type: "post",
        },
        {
            id: "wikileaks",
            label: formatMessage({ id: "global.wikileaks" }),
            icon: "icon icon-wikileaks",
            path: "/wikileaks/posts",
            platform: "wikileaks",
            type: "post",
        },
        {
            id: "newspaper",
            label: formatMessage({ id: "global.newspaper" }),
            icon: "icon icon-newspaper",
            path: "/newspaper/posts",
            platform: "newspaper",
            type: "post",
        },
        {
            id: "newspaperagencies",
            label: formatMessage({ id: "global.newspaperagencies" }),
            icon: "icon icon-newspaper",
            path: "/newspaper/agencies",
            platform: "newspaper",
            type: "agency",
        },
        {
            id: "linkedincompany",
            label: formatMessage({ id: "global.linkedin" }),
            path: "/linkedin/company",
            platform: "linkedin",
            type: "post",
        },
        {
            id: "linkedinschool",
            label: formatMessage({ id: "global.linkedin" }),
            path: "/linkedin/school",
            platform: "linkedin",
            type: "post",
        },
    ];

    if (keys === "all") {
        if (!applyAccess) {
            return platforms;
        } else {
            return platforms.filter((platItem) => {
                return UserAccess.can(platItem.id, "SearchPlatforms");
            });
        }
    }

    let newKeys = _.isString(keys) ? [keys] : keys;

    let finalFilters;

    if (!applyAccess) {
        finalFilters = platforms.filter((platform) => {
            return newKeys.indexOf(platform.id) > -1;
        });
    } else {
        finalFilters = platforms.filter((platform) => {
            return newKeys.indexOf(platform.id) > -1 && UserAccess.can(platform.id, "SearchPlatforms");
        });
    }

    return _.isString(keys) ? finalFilters[0] || {} : finalFilters;
};

/*برای از بین بردن اسپم برای مسیج های فارسی از این فانکشن استفاده کنید*/
export const FormattedSimpleMsg = (props) => (
    <FormattedMessage {...props}>{(txt) => <Fragment>{txt}</Fragment>}</FormattedMessage>
);

// function for dynamic sorting object by a property
export const dynamicSort = (property) => {
    let sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    return function (a, b) {
        const result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
    };
};

// برای آدرس آیتم هر بستر
export const originUrl = (platform, data, user) => {
    const { id, code, url, username: linkedinUsername } = data;
    const { username } = user;
    const userId = user.relationid;
    const resourceId = data['resource.id'];

    let href = "";
    let info = "";
    let source = "";

    const entityUrl = "profile/entity";
    const contentUrl = "profile/content";

    switch (platform) {
        case "/telegram/posts":
            // href = `https://telegram.me/${username}/${id}`;
            href = url;
            info = `/${contentUrl}/telegram-channels/${id}`;
            source = `/${entityUrl}/telegram-channels/${userId || id}`;
            break;

        case "/telegram/comments":
            href = url;
            info = `/${contentUrl}/telegram-user/${id}`;
            source = `/${entityUrl}/telegram-user/${resourceId || userId || id}`;
            break;

        case "/telegram/groups/posts":
            href = url ? `${url}/${id}` : "";
            info = `/${contentUrl}/telegram-groups/${id}`;
            source = `/${entityUrl}/telegram-groups/${userId || id}`;
            break;

        case "/telegram/channels":
            href = `https://telegram.me/${username}`;
            info = `/${entityUrl}/telegram-channels/${id}`;
            source = `/${entityUrl}/telegram-channels/${userId || id}`;
            break;

        case "/telegram/users":
            href = username ? `https://telegram.me/${username}` : "";
            info = `/${entityUrl}/telegram-user/${id}`;
            source = `/${entityUrl}/telegram-user/${userId || id}`;
            break;

        case "/telegram/groups":
        case "/telegram/users/{id}/groups":
            href = url ? `${url}` : "";
            info = `/${entityUrl}/telegram-groups/${id}`;
            source = `/${entityUrl}/telegram-groups/${userId || id}`;
            break;

        case "/telegram/users/{id}/invite_users":
            href = username ? `https://telegram.me/${username}` : "";
            info = `/${entityUrl}/telegram-user/${id}`;
            source = `/${entityUrl}/telegram-groups/${userId || id}`;
            break;

        case "/instagram/posts":
            href = `https://www.instagram.com/p/${code}`;
            info = `/${contentUrl}/instagram/${id}`;
            source = `/${entityUrl}/instagram/${userId}`;
            break;

        case "/instagram/comments":
            href = `https://www.instagram.com/p/${data["post.code"]}`;
            info = `/${contentUrl}/instagram/${id}`;
            source = `/${entityUrl}/instagram/${userId}`;
            break;

        case "/instagram/users":
        case "/instagram/users/followers":
        case "/instagram/users/by_subject":
            href = `https://www.instagram.com/${username}`;
            info = `/${entityUrl}/instagram/${id}`;
            source = `/${entityUrl}/instagram/${userId || id}`;
            break;

        case "/twitter/posts":
            href = `${url}`; //`https://twitter.com/${username}/status/${id}`;
            info = `/${contentUrl}/twitter/${id}`;
            source = `/${entityUrl}/twitter/${userId}`;
            break;

        case "/twitter/users":
        case "/twitter/users/followers":
        case "/twitter/users/by_subject":
            href = `https://twitter.com/${username}`;
            info = `/${entityUrl}/twitter/${id}`;
            source = `/${entityUrl}/twitter/${userId || id}`;
            break;

        case "/facebook/posts":
            href = `https://facebook.com/${id}`;
            info = `/${contentUrl}/facebook/${id}`;
            source = `/${entityUrl}/facebook/${userId}`;
            break;

        case "/facebook/users":
        case "/facebook/users/by_subject":
            href = username ? `https://facebook.com/${username}` : "";
            info = `/${entityUrl}/facebook/${id}`;
            source = `/${entityUrl}/facebook/${userId || id}`;
            break;

        case "/facebook/pages":
        case "/facebook/pages/by_subject":
            href = username ? `https://facebook.com/${username}` : "";
            info = `/${entityUrl}/facebook/${id}`;
            source = `/${entityUrl}/facebook/${userId || id}`;
            break;

        case "/search_engine/posts":
            href = `${url}`;
            info = `/${contentUrl}/search-engine/${id}`;
            //source = `/${entityUrl}/facebook/${userId}`;
            break;

        case "/news/posts":
            href = `${url}`;
            info = `/${contentUrl}/news/${id}`;
            source = `/${entityUrl}/news/${userId}`;
            break;

        case "/news/agencies/by_subject":
        case "/news/agencies":
            href = `${url}`;
            info = `/${entityUrl}/news/${id}`;
            source = `/${entityUrl}/news/${userId || id}`;
            break;

        case "/advertisement/posts":
            href = `${url}`;
            info = `/${contentUrl}/advertisement/${id}`;
            //source = `/${entityUrl}/facebook/${userId}`;
            break;

        case "/dumper/posts":
            href = `${url}`;
            info = `/${contentUrl}/dumper/${id}`;
            break;
        case "/wikileaks/posts":
            href = `${url}`;
            info = `/${contentUrl}/wikileaks/${id}`;
            break;

        case "/dunro/posts":
            href = `https://dunro.com/page/${id}`;
            info = `/${contentUrl}/dunro/${id}`;
            break;

        case "/ketabavval/posts":
            href = `${url}`;
            info = `/${contentUrl}/ketabavval/${id}`;
            break;

        case "/blog/posts":
            href = `${url}`;
            info = `/${contentUrl}/blog/${id}`;
            break;

        case "/rrk/posts":
            href = `http://www.rrk.ir/News/ShowOldNews.aspx?Code=${id}`;
            info = `http://www.rrk.ir/News/ShowOldNews.aspx?Code=${id}`;
            source = `http://www.rrk.ir/News/ShowOldNews.aspx?Code=${id}`;
            break;

        case "/linkedin/profiles":
            href = `https://www.linkedin.com/in/${linkedinUsername}`;
            info = `/${entityUrl}/linkedin/${id}`;
            source = `/${entityUrl}/linkedin/${id}`;
            break;

        case "/linkedin/company":
            href = `https://www.linkedin.com/company/${id}`;
            info = `https://www.linkedin.com/company/${id}`;
            source = `https://www.linkedin.com/company/${id}`;
            break;

        case "/linkedin/school":
            href = `https://www.linkedin.com/school/${id}`;
            info = `https://www.linkedin.com/school/${id}`;
            source = `https://www.linkedin.com/school/${id}`;
            break;

        default:
            break;
    }
    return {
        href: href,
        info: info,
        source: source,
    };
};

// گرفتن بازه زمانی براساس رینح زمان
export const rangeTime = (range) => {
    let from, to;
    to = moment().format("YYYY-MM-DD HH:mm:ss"); // today
    switch (range) {
        case "6h":
            from = moment().add(-6, "hours").format("YYYY-MM-DD HH:mm:ss");
            break;
        case "12h":
            from = moment().add(-0.5, "days").format("YYYY-MM-DD HH:mm:ss");
            break;
        case "24h":
            from = moment().add(-1, "days").format("YYYY-MM-DD HH:mm:ss");
            break;
        case "today":
            from = getDateTime().split(" ")[0] + " 00:00:00";
            break;
        case "2d":
            from = moment().add(-2, "days").format("YYYY-MM-DD HH:mm:ss");
            break;
        case "1w":
        case "oneWeek":
            from = moment().add(-7, "days").format("YYYY-MM-DD HH:mm:ss");
            break;
        case "1m":
        case "oneMonth":
            from = moment().add(-1, "month").format("YYYY-MM-DD HH:mm:ss");
            break;
        default:
            from = "";
            to = "";
            break;
    }

    return {
        from,
        to,
    };
};

// گرفتن بازه زمانی براساس رینح زمان
export const durationToDay = (range) => {
    let days;
    switch (range) {
        case "6h":
            days = 0.25;
            break;
        case "12h":
            days = 0.5;
            break;
        case "24h":
            days = 1;
            break;
        case "today":
            days = 0;
            break;
        case "2d":
            days = 2;
            break;
        case "1w":
        case "oneWeek":
            days = 7;
            break;
        case "1m":
        case "oneMonth":
            days = 30;
            break;
        default:
            days = 0;
            break;
    }

    return days;
};

export const todayToSecond = () => {
    const originalFormat = "YYYY-M-D HH:mm:ss";
    const from = moment().format("YYYY-MM-DD 00:00:00");
    const fTo = moment().format(originalFormat);
    return Math.round(moment(fTo, originalFormat).diff(moment(from, originalFormat)) / 1000);
};

// گرفتن بازه زمانی براساس رینح زمان
export const durationToSecond = (range) => {
    let time;
    const h = 60 * 60;
    const d = 24 * h;
    switch (range) {
        case "6h":
            time = 6 * h;
            break;
        case "12h":
            time = 12 * h;
            break;
        case "24h":
            time = d;
            break;
        case "today":
            time = 0;
            break;
        case "2d":
            time = 2 * d;
            break;
        case "1w":
        case "oneWeek":
            time = 7 * d;
            break;
        case "2w":
        case "twoWeek":
            time = 14 * d;
            break;
        case "1m":
        case "oneMonth":
            time = 30 * d;
            break;
        case "6m":
            time = 30 * 6 * d;
            break;
        case "12m":
        case "oneYear":
            time = 30 * 12 * d;
            break;
        case "-1":
            time = -1;
            break;
        default:
            time = 0;
            break;
    }

    return time;
};
/**
 * ایجاد متد ریکرسیو جهت تولید دیتای درختی
 * */
export const getItemsData = (items) => {
    let data = [];
    items.forEach((item) => {
        data.push({
            ["key"]: item["id"],
            ["value"]: item["id"],
            ["title"]: item["name"],
            ["description"]: item["description"],
            ["pId"]: item["parentId"],
            ["children"]: item["children"] ? getItemsData(item["children"]) : null,
        });
    });

    return data;
};

export const getTypeDescriptionFilter = (type) => {
    if (type === "post") {
        return (
            <span style={{ color: "#ff5722", fontSize: 12, paddingRight: 5 }}>
                (<i className="icon icon-copy" /> مبتنی بر پست ){" "}
            </span>
        );
    } else if (type === "comment") {
        return (
            <span style={{ color: "#1d8cf8", fontSize: 12, paddingRight: 5 }}>
                (<i className="icon icon-comment-icon" /> مبتنی بر کامنت ){" "}
            </span>
        );
    } else {
        return null;
    }
};

/**
 * تابع کاما گذاری روی اعداد
 * @param {*} x ورودی عدد
 */
export const numberWithCommas = (x) => {
    return _.round(x, 3)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

/**
 * get Validate Global Filters
 * @param globalFilters
 * @param platform
 */
export const getValidateGlobalFilters = (globalFilters, platform, type) => {
    if (type === "content") {
        return {};
    }

    const {
        from,
        to,
        time_duration,
        query,
        rules,
        categoryId,
        tagId,
        exists,
        resource_ids,
        resourceIdsDetails,
        resource_objects,
        resource_objects_resource_ids,
        resource_objects_post_resource_ids,
        categories,
        sub_categories,
    } = globalFilters;
    // console.log("--------globalFilters-----------", globalFilters);

    let filters = {};

    if (categories && !_.isEmpty(categories)) {
        categories.forEach((cat, index) => {
            if (cat) {
                filters[`max_${cat}`] = globalFilters[`max_${cat}`];
                filters[`min_${cat}`] = globalFilters[`min_${cat}`];
                filters[`${cat}`] = globalFilters[`${cat}_checked`];
                filters[`prob_categories[${index}][from]`] = globalFilters[`prob_categories[${index}][from]`];
                filters[`prob_categories[${index}][title]`] = globalFilters[`prob_categories[${index}][title]`];
                filters[`prob_categories[${index}][to]`] = globalFilters[`prob_categories[${index}][to]`];
            }
        });
        filters.categories = categories;
    }
    if (sub_categories && !_.isEmpty(sub_categories)) {
        filters.sub_categories = sub_categories;
    }

    if (time_duration && !_.isEmpty(time_duration)) {
        filters.time_duration = time_duration;
    } else {
        if (!_.isEmpty(from)) {
            filters.from = from;
        }

        if (!_.isEmpty(to)) {
            filters.to = to;
        }
    }
    /**
     * We use query rule id or customized query as query filter
     */
    if (query && !["subject", "query-file"].includes(type)) {
        if (query.hasCustomQuery) {
            if (query.parsedQuery) {
                filters.query = query.parsedQuery;
            }
        } else if (!query.hasCustomQuery && query.selectedKeyword && rules) {
            const currRule = rules.find((rule) => rule.id === query.selectedKeyword);

            if (currRule) {
                let rulePlatforms = currRule.platforms || []; //_.isString(currRule.platform) ? JSON.parse(currRule.platform) : [];

                /**
                 * check if currRule is correct and has platform of current box
                 */
                if (rulePlatforms.includes(platform)) {
                    filters.query = query.selectedKeyword; //currRule.parsed_query;
                }
            }
        }
    }

    if (categoryId) {
        filters.cat_id = categoryId;
    }

    if (tagId && !["entity", "entities-tag", "query-file"].includes(type)) {
        filters.tag_id = tagId;
    }

    if (exists && !_.isEmpty(exists)) {
        filters.exists = exists;
    }

    //convert resourceIds to resource_ids later. (on sanitizeSearchParams function)
    if (!["entity", "entities-tag", "query-file"].includes(type)) {
        if (resource_ids) {
            filters.resource_ids = resource_ids;
        }

        if (resourceIdsDetails) {
            filters.resourceIdsDetails = resourceIdsDetails;
        }

        if (resource_objects) {
            filters.resource_objects = resource_objects;
        }
        if (resource_objects_resource_ids) {
            filters.resource_objects_resource_ids = resource_objects_resource_ids;
        }
        if (resource_objects_post_resource_ids) {
            filters.resource_objects_post_resource_ids = resource_objects_post_resource_ids;
        }
    }

    if (type === "query") {
        delete filters.query;
    }

    return filters;
};

export const isValidJSONString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

/**
 * هندل کردن مقادیر بازه ای
 */
export const handleRangeParameters = (paramsValue) => {
    if (!paramsValue) {
        return {};
    }

    const temp = { ...paramsValue };
    Object.keys(paramsValue).forEach((item, index) => {
        if (item.includes("_checked")) {
            if (!paramsValue[item]) {
                const param = item.replace("_checked", "");
                delete temp[`min_${param}`];
                delete temp[`max_${param}`];
            }

            delete temp[item];
        }
    });

    return temp;
};

export const onEnter = (e, callback, ...args) => {
    const code = e.keyCode || e.which;
    if (code === 13 && _.isFunction(callback)) {
        callback(...args);
    }
};

/**
 * ولیدیت کردن بازه زمانی
 * @param {*} params پارمترهای ارسالی برای ولید کردن
 */
export const dateValidate = (params) => {
    const { from, to } = params;

    if (from && to) {
        if (Date.parse(from) < Date.parse(to)) {
            return true;
        } else {
            return { id: "global_function.date_validate.error.start_before_end" };
        }
    } else if (!from && !to) {
        return true;
    } else {
        return { id: "global_function.date_validate.error.enter_complete" };
    }
};

export const randomBgColor = (text = null) => {
    let randNum;
    if (text) {
        let sum = 0;
        for (var i = 0; i < text.length; i++) {
            sum += text[i].charCodeAt(0);
        }
        randNum = sum % 10;
    } else {
        randNum = Math.floor(Math.random() * Math.floor(10));
    }
    let classname = `rand-bg-${randNum}`;
    return classname;
};

/**
 * تولید کلاس رنگ پس زمینه رندوم
 * @param {*} name اسم کاربر جهت تولید کد رنگ مشترک برای یک اسم
 */
export const charAvatar = (name) => {
    try {
        let trimText = name.trim();
        let splitText = trimText.split(" ");
        let a,
            b = "";
        if (splitText.length > 1) {
            a = splitText[0][0];
            b = splitText[1][0];
        } else if (splitText.length == 1) {
            a = splitText[0][0];
            b = splitText[0].length > 1 && splitText[0][1];
        } else {
            a = "X";
            b = "Y";
        }
        return a + "‌" + b;
    } catch (e) {
        return "XY";
    }
};

/**
 * شروع جدول اسکرول دار از ابتدای بالا راست
 */
export const startTableScrollFromRight = () => {
    setTimeout(() => {
        if (!document.querySelector(".ant-table-scroll .ant-table-header")) {
            return;
        }
        document.querySelector(".ant-table-scroll .ant-table-header").scrollTo(2000, 0);
        document.querySelector(".ant-table-scroll .ant-table-body").scrollTo(2000, 0);
    }, 100);
};

/**
 * fix platform names for user access because of platform names on search not equal to backend standard names
 * @param item
 * @returns {*}
 */
export const fixPlatformNameForAccess = (item) => {
    const wrongPlatformsNames = [
        "telegramposts",
        "facebookposts",
        "instagramposts",
        "twitterposts",
        "dumperposts",
        "wikileaksposts",
        "advertisementposts",
        "dunroposts",
        "blogposts",
        "ketabavvalposts",
        "rrkposts",
        "search_engineposts",
        "newsposts",
    ];

    return wrongPlatformsNames.includes(item) ? item.replace("posts", "") : item;
};

/**
 * make clean parameters before sending to server
 * means APIs that we send to server by /search
 * apply to widget builder now
 * @param params
 * @param part search or widget builder
 * @searchConfig part search or widget builder
 * @returns {*}
 */
export const sanitizeSearchParams = (params, part = "widget-builder", searchConfig) => {
    const storageSearch = JSON.parse(localStorage.getItem("search")) || null;
    // console.log("---raw params----", params);

    /*if (params.searchFilters) {
		params = {...params, ...params.searchFilters}
		delete params.searchFilters;
	}*/

    Object.keys(params).forEach((key) => params[key] === false && delete params[key]);

    if (part === "search") {
        if ((!params.from || !params.to) && !params.time_duration && searchConfig) {
            const gp = searchConfig.general_params;
            params = {
                ...params,
                from: gp.from,
                to: gp.to,
                time_duration: gp.time_duration,
                extracted_q: gp.searchArea,
            };
        }
    }

    if (!_.isUndefined(params.time_duration) && params.time_duration && !_.isNumber(params.time_duration)) {
        params.time_duration = durationToSecond(params.time_duration);
    }

    if (params?.sentiment) {
        params.sentiment = params?.sentiment?.toLowerCase();
    }

    //validation platforms of resource_ids for current apiPath specially general filters ---- resourceIdsDetails is related only to general filtres
    if (
        !_.isUndefined(params.resource_ids) &&
        !_.isUndefined(params.resourceIdsDetails) &&
        !_.isUndefined(params.api_path)
    ) {
        let acceptableResources = APIPathsOfPlatform[params.api_path]
            ? APIPathsOfPlatform[params.api_path].resources
            : [];
        let resourceIds = [];
        if (!_.isEmpty(acceptableResources)) {
            _.isArray(params.resourceIdsDetails) &&
                params.resourceIdsDetails.forEach((resource) => {
                    if (acceptableResources.includes(resource.platform)) {
                        resourceIds = [...resourceIds, ...resource.ids];
                    }
                });
            if (resourceIds && resourceIds.length > 0) {
                params.resource_ids = resourceIds;
            } else {
                delete params.resource_ids;
            }
        }
    }

    if (notPostSearchList.includes(params.api_path) && !_.isUndefined(params.resource_ids)) {
        params.ids = params.resource_ids;
        delete params.resource_ids;
    }

    if (!_.isUndefined(params.min_advert_noise)) {
        params.min_advert_noise = params.min_advert_noise / 100;

        params.max_advert_noise = params.max_advert_noise / 100;
    }

    const uselessParam = [
        "entity",
        "name",
        "resource_objects",
        "resource_objects_resource_ids",
        "resource_objects_post_resource_ids",
        "resourceIdsDetails",
        "apiPath",
        "query_field",
        "fields",
        "apply",
        "tagContent",
    ]; // نیازی در ارسال این پارامتر ها نیست

    if (part === "search") {
        uselessParam.push("type");
    }

    const ignoreNullValue = ["from", "to", "time_duration", "time"]; // نیازی در ارسال خالی این پارامترها نیست
    Object.keys(params).forEach((itemKey) => {
        if (uselessParam.includes(itemKey) || (ignoreNullValue.includes(itemKey) && _.isNull(params[itemKey]))) {
            delete params[itemKey];
        }
    });

    //::DELETE BY DARBANDI
    // if (!params.totalCount) {
    //     params.totalCount = 0;
    // }

    // TODO: check hashtag in first of phrase
    // if (params.q && params.q.charAt(0) === '#' && params.q.split(' ').length === 1) {
    // 	params.extracted_hashtag = params.q.substring(1);
    // 	delete params.q
    // }

    if (params.sort === "random") {
        params.sort = params.sort + "_" + storageSearch.random;
    }

    const finalParamsKeys = Object.keys(params).filter(
        (item) =>
            (_.isArray(params[item]) && !_.isEmpty(params[item])) ||
            (_.isPlainObject(params[item]) && Object.keys(params[item]).length > 0) ||
            (params[item] && !_.isArray(params[item]) && !_.isPlainObject(params[item])) ||
            params[item] === false ||
            params[item] === 0,
    );

    let finalParams = {};

    finalParamsKeys.forEach((param) => {
        finalParams[param] = params[param];
    });

    // handle unchecked values
    finalParams = handleRangeParameters(finalParams);

    return _.cloneDeep(finalParams);
};

export const getInstagramMediaType = (type) => {
    let mediaType = "";

    switch (parseInt(type)) {
        case 1:
            mediaType = "video";
            break;
        case 2:
            mediaType = "image";
            break;
        case 8:
            mediaType = "slider";
            break;
        default:
            mediaType = "unknown";
    }

    return mediaType;
};

export const substring = (text, number = 10) => {
    if (_.isEmpty(text)) return "";

    if (text.length <= number) return text;

    return text.substr(0, number) + " ...";
};

const cacheCallbacks = {};

/**
 * start to cache all widgets data after change global filter on widget builder
 */
export const dashboardSaveCache = (id, params) => {
    const prevDashboardDataCache = localStorage.getItem("dashboardDataCache")
        ? JSON.parse(localStorage.getItem("dashboardDataCache"))
        : [];

    localStorage.setItem(
        "dashboardDataCache",
        JSON.stringify([
            ...prevDashboardDataCache,
            {
                id,
                params,
            },
        ]),
    );
};

export const dashboardUpdateCache = (id, result) => {
    const prevDashboardDataCache = localStorage.getItem("dashboardDataCache")
        ? JSON.parse(localStorage.getItem("dashboardDataCache"))
        : [];

    if (cacheCallbacks[id]) {
        cacheCallbacks[id].forEach((callback) => {
            callback(result);
        });
    }

    localStorage.setItem(
        "dashboardDataCache",
        JSON.stringify(
            prevDashboardDataCache.map((item) => {
                if (item.id === id) {
                    item.result = result;
                }
                return item;
            }),
        ),
    );
};

export const dashboardSetCacheCallback = (id, callback) => {
    if (!cacheCallbacks[id]) {
        cacheCallbacks[id] = [];
    }

    cacheCallbacks[id].push(callback);
};

/**
 * reset current cache widget data immediately after change global filter
 */
export const dashboardResetCache = () => {
    localStorage.setItem("dashboardDataCache", "");
};

/**
 * تبدیل فایل های بیس 64 به بلاب برای ارسال در فرم دیتا
 * @param {ورودی به شکل بیس 64} b64Data
 */
export const b64toBlob = (b64Data) => {
    if (_.isEmpty(b64Data)) return;

    const block = b64Data.split(";");
    // Get the content type of the image
    const contentType = block[0].split(":")[1]; // In this case "image/gif"
    // get the real base64 content of the file
    const realData = block[1].split(",")[1];

    const sliceSize = 512;

    const byteCharacters = atob(realData);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
};

/**
 * دریافت وضعیت سایز ریسپانسیو هر المنت
 * @param {*} element
 */
export const getResponsiveSize = (element) => {
    let parentWidth = element ? element.offsetWidth : window.innerWidth;

    if (parentWidth < 481) {
        return "small";
    } else if (parentWidth < 961) {
        return "medium"; // "medium"
    } else if (parentWidth < 1440) {
        return "large";
    } else {
        return "large"; // "extra-large"
    }
};

/**
 * This function capitalize the first letter of a string in JavaScript
 * @param string
 * @returns {string}
 */
export const ucFirst = (string) => {
    return string?.charAt(0).toUpperCase() + string?.slice(1);
};

// مپینگ آیکن مدیا تایپ
export const mediaTypeIconMapper = (type) => {
    switch (type.toLowerCase()) {
        case "image":
            return "icon icon-img";
        case "video":
            return "icon icon-video";
        case "audio":
            return "icon icon-audio";
        case "slide":
            return "icon icon-slide";
        case "gif":
            return "icon icon-gif";
        default:
            return "icon icon-file";
    }
};

// پیشوند اسم برای تفکیک نام پارامتر های هر فیلتر
export const getfilterParamsPrefix = (searchField) => {
    switch (searchField.toLowerCase()) {
        case "nationalities":
            return "nationality_";
        default:
            return "";
    }
};

/**
 * دریافت پلتفرم های مجاز برای بروزرسانی
 * @param {*} path آدرس پلتفرم ها در ای پی آی سرچ
 */
export const allowUpdatePlatform = (path) => {
    const allowPlatform = [];
    // const allowPlatform = ["/telegram/posts", "/instagram/posts", "/instagram/users", "/telegram/channels"];
    const temp = allowPlatform.includes(path);

    return temp;
};

/**
 * متد بازگردانی آدرس آواتار از ایمیج و آواتار
 * @param {*} avatar avatar url
 * @param {*} image image url
 */
export const getUrlFromAvatarImage = (avatar, image, order = "avatar") => {
    if (order === "avatar") {
        if (!_.isEmpty(avatar)) {
            const avatarUrl = avatar.startsWith("http") ? avatar : imagesStaticUrl + avatar;
            return avatarUrl?.replace("_normal", "");
        } else if (!_.isEmpty(image)) {
            return image?.replace("_normal", "");
        } else {
            return "/images/no_image.jpg";
        }
    } else {
        if (!_.isEmpty(image)) {
            return image?.replace("_normal", "");
        } else if (!_.isEmpty(avatar)) {
            const avatarUrl = avatar.startsWith("http") ? avatar : imagesStaticUrl + avatar;
            return avatarUrl?.replace("_normal", "");
        } else {
            return "/images/no_image.jpg";
        }
    }
};

/**
 * متد بازگردانی آدرس آواتار
 * @param {*} avatar avatar url
 * @param {*} image image url
 */
export const getUrlFromAvatar = (avatar) => {
    if (!_.isEmpty(avatar)) {
        return avatar.startsWith("http") ? avatar : imagesStaticUrl + avatar;
    } else {
        return "/images/no_image.jpg";
    }
};

export const getWideImg = (img, platform) => {
    if (platform === "twitter") return img?.replace("normal", "400x400");
    if (platform === "instagram") return img;
    return img;
};

/**
 * بریدن بخشی از محتوا
 * @param {*} str
 * @param {*} num
 */
export const cutString = (str, num = 10) => {
    if (_.isEmpty(str) || str.length <= num) return str;
    str = str.substring(0, num) + " ...";
    return str;
};

export const loadAssetsImage = (image) => {
    let imgAddress = null;
    try {
        imgAddress = require(`./assets/img/${image}`);
    } catch (error) {
        imgAddress = img_planing_warning;
    }
    return imgAddress;
};

/**
 * بزرگ کردن کاراکتر اول یک کلمه
 * @param {*} s
 */
export const capitalize = (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
};

/**
 * کلاس  آیکن های مربوط به استتوس های مودال توضیحات
 * @param {*} operationAction
 * @param {*} status
 */
export const generateClassNameIconModalDescription = (operationAction, status) => {
    switch (operationAction) {
        case "status":
            switch (status) {
                case "no_need":
                    return "icon history-icon default icon-no-nead";
                case "replied":
                    return "icon history-icon default icon-replyed";
                case "pending":
                    return "icon history-icon default icon-pending";
                case "closed":
                    return "icon history-icon default icon-done";
                default:
                    break;
            }
        case "assign":
            return "icon history-icon default icon-assign";
        case "favorite":
            return "icon history-icon default icon-like";
        case "quote":
            return "icon history-icon default icon-quote";
        case "reply_comment":
        case "reply":
            return "icon history-icon default default icon-reply";
        case "add_comment":
            return "icon history-icon default icon-reply";
        case "add_account":
            return "icon history-icon default icon-add";
        case "retweet":
            return "icon history-icon default icon-tweet";
        case "delete_comment":
            return "icon history-icon default icon-delete";
        case "untweet":
            return "icon history-icon default icon-delete";
        default:
            return "";
    }
};

/**
 * آیکن های مربوط به استتوس های اساینمنت
 * @param {*} operationAction
 * @param {*} status
 */
export const generateAssignmentHistoryIcon = (operationAction, status) => {
    switch (operationAction) {
        case "change_status":
            switch (status) {
                case "no_need":
                    return <i className="icon history-icon default icon-no-nead"></i>;
                case "replied":
                    return <i className="icon history-icon default icon-replyed"></i>;
                case "pending":
                    return <i className="icon history-icon default icon-pending"></i>;
                case "closed":
                    return <i className="icon history-icon default icon-done"></i>;
                default:
                    break;
            }
        case "assign":
            return <i className="icon history-icon default icon-assign"></i>;
        case "favorite":
        case "unfavorite":
            return <i className="icon history-icon default icon-like"></i>;
        case "quote":
            return <i className="icon history-icon default icon-quote"></i>;
        case "reply_comment":
        case "reply":
            return <i className="icon history-icon default default icon-reply"></i>;
        case "add_comment":
            return <i className="icon history-icon default icon-reply"></i>;
        case "add_account":
            return <i className="icon history-icon default icon-add"></i>;
        case "retweet":
            return <i className="icon history-icon default icon-tweet"></i>;
        case "delete_comment":
            return <i className="icon history-icon default icon- icon-delete"></i>;
        case "untweet":
        case "unretweet":
            return <i className="icon history-icon default icon- icon-delete"></i>;

        default:
            break;
    }
};

/**
 * بررسی اندازه صفحه نمایش برای محاسبات در جاوااسکریپگت
 * @param {*} type
 */
export const mediaSizeValidation = (type) => {
    const media = {
        xs: window.matchMedia("(max-width: 575px)").matches,
        sm: window.matchMedia("(min-width: 576px) and (max-width: 767px)").matches,
        md: window.matchMedia("(min-width: 768px) and (max-width: 991px)").matches,
        xl: window.matchMedia("(min-width: 992px) and (max-width: 1199px)").matches,
        xxl: window.matchMedia("(min-width: 1200px)").matches,
    };
    return type ? media[type] : media;
};

/**
 * دریافت آپشن های مربوط با پروژه
 * @param {*} name
 */
export const getProjectOptions = (name) => {
    const regex = new RegExp(/[:|-|.|\/|-]/, "g");
    const urlOrigin = window.location.host.replace(regex, "");
    const option = require(`./options/${name ? name : urlOrigin}`);
    return option;
};

/**
 * تبدیل تایم دیوریشن به مقدار استرینگ ا هفته و ...
 * @param {*} timeDuration
 */
export const changeTimeDurationToString = (timeDuration) => {
    let time;
    switch (timeDuration) {
        case 0:
            time = "today";
            break;
        case 21600:
            time = "6h";
            break;
        case 43200:
            time = "12h";
            break;
        case 86400:
            time = "24h";
            break;
        case 604800:
            time = "1w";
            break;
        case 1209600:
            time = "2w";
            break;
        case 2592000:
            time = "1m";
            break;
        case 15552000:
            time = "6m";
            break;
        case 31104000:
            time = "12m";
            break;
        default:
            time = 0;
            break;
    }

    return time;
};

/**
 * مقایسه دو آرایه
 * @param {*} a
 * @param {*} b
 */
export const arraysEqual = (a, b) => {
    if (a === null || a === undefined) {
        a = [];
    }
    if (b === null || b === undefined) {
        b = [];
    }
    if (a === b) return true;
    if (isEqual(a, b)) return true;
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; ++i) {
        if (!b.includes(a[i])) return false;
        if (!a.includes(b[i])) return false;
    }
    return true;
};

/**
 * حذف رنج دسته بندی محتوا از پارامترهای سرچ
 * @param {*} params
 */
export const removeCategoryRangeFromSearchParams = (params) => {
    const categories = Object.keys(categorySubCategory);
    categories.forEach((category) => {
        delete params[`min_${category}`];
        delete params[`max_${category}`];
    });
    return params;
};

/**
 * تبدیل مقدار عددی رنج دسته بندی محتوا از عدد صحیح به درصد
 * @param {*} params
 */
export const toPercentCategoryRangeInSearchParams = (params) => {
    const keys = Object.keys(params);
    keys.forEach((key) => {
        if (key.includes("prob_categories") && !key.includes("title")) {
            params[key] = +params[key] / 100;
        }
    });
    return params;
};

/**
 * تولید عدد رندوم
 * @param {*number} max سقف عدد
 */
export const randomNumber = (max = 10000) => {
    const num = Math.floor(Math.random() * max);
    return num;
};

/**
 * بررسی ورژن کروم
 * @param {*} version
 * @returns
 */
export const isChrome = (version) => {
    var test = navigator.userAgent.match(/chrom(?:e|ium)\/(\d+)\./i);
    if (test) {
        return parseInt(test[1], 10) === version;
    }
    return false;
};

/** هایلایت کردن متن
 * @param {*string} text
 * @param {*string} highlight
 * @param {*string} color
 */
export const highlighter = (content, highlight) => {
    let newContent = content;
    highlight &&
        highlight.forEach((item, i) => {
            newContent = newContent?.replace(
                new RegExp(`( ${item?.text} )`, "g"),
                `<span style="background-color:${item?.color}">&nbsp;${item?.text}&nbsp;</span>`,
            );
        });
    return newContent;
};

/**
 * نرمال کردن متن برای خروجی pdf
 * @param {*html} content
 */
export const normalizerPdfContent = (content) => {
    return content;
};

/**
 * متن
 * @param {*text} text
 * @param {instagram | twitter } type
 */
export const twitterHashtag = (text) => {
    // تبدیل هشتگ به لینک در سایت اصلی

    const persianCharacter = "\u0600-\u06FF\u202C\u064B\u064C\u064E-\u0652\u06F0-\u06F9\u0622\u0627\u0628\u067E\u062A-\u062C\u0686\u062D-\u0632\u0698\u0633-\u063A\u0641\u0642\u06A9\u06AF\u0644-\u0648\u06CC";
    const allCharacter = persianCharacter+"_\u0660-\u0669\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
    const pattern = "([^"+allCharacter+"0-9&])([#])(["+allCharacter+"\u200c\u20090-9]*(?:["+allCharacter+"\u200c\u2009]+)["+allCharacter+"\u200c\u20090-9]*)";
    const replace = new RegExp(pattern,"g");
    const subst = `$1<a target="_blank" href="https://twitter.com/hashtag/$3"><bdi>#$3</bdi></a>`;
    // به دلیل اینکه نان-ورد باندری ها در رجکس کار نمیکرد مجبور شدم برای رفع مشکل اینکه اولین حرف ممکنه هشتگ باشه، متنی اضافه و کم کنم
    // (\B[#])([\u200c\u2009\u0600-\u06FFa-zA-Z0-9_&]*(?:[\u0600-\u06FFa-zA-Z_&]+)[\u200c\u2009\u0600-\u06FFa-zA-Z0-9_&]*)
    text = "test " + text;
    text = text?.replace(replace, subst);
    return text?.substr(5);
}
export const autoLinkDescription = (text, type = "instagram") => {
    // emojiSelector = "\u00a9\u00ae\u2000-\u3300\ud83c\ud000-\udfff\ud83d\ud000-\udfff\ud83e\ud000-\udfff";
    // halfAndThinSpaceSelector = "\u200c\u2009";
    // allLanguageLettersWithNumbers = "A-Za-z0-9\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC\s\uD800\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uD801\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uD802\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91\uD803\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uD804\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uD805\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19\uD806\uDCA0-\uDCDF\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8\uD807\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uD808\uDC00-\uDF99\uD809\uDC80-\uDD43\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uDC00-\uDFFF\uD80D\uDC00-\uDC2E\uD811\uDC00-\uDE46\uD81A\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F\uD81B\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uD821\uDC00-\uDFEC\uD822\uDC00-\uDEF2\uD82C\uDC00-\uDD1E\uDD70-\uDEFB\uD82F\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uD835\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uD83A\uDC00-\uDCC4\uDD00-\uDD43\uD83B\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB\uD869\uDC00-\uDED6\uDF00-\uDFFF\uD86D\uDC00-\uDF34\uDF40-\uDFFF\uD86E\uDC00-\uDC1D\uDC20-\uDFFF\uD873\uDC00-\uDEA1\uDEB0-\uDFFF\uD87A\uDC00-\uDFE0\uD87E\uDC00-\uDE1D";
    // allLanguageLettersWithOutNumbers = "\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
    const baseMentionAndHashtagUrl = {
        instagram: { mention: "https://www.instagram.com/", hashtag: "https://www.instagram.com/explore/tags/" },
        twitter: { mention: "https://twitter.com/", hashtag: "https://twitter.com/hashtag/" },
    };
    // text="#سلام‌یضصث__";
    // text+="#سینا__";
    // text+="#sina";
    // text+="#sina99";
    // text+="#Mehrzad";
    // text+="#Mehrzad88";
    // text+="#سینا.";
    // text+="#سینا-";
    // text+="*780#";
    // text+="#880";
    // text+=" https://www.regextester.com/95875 ";

    text = text?.replace(/([<>])/g, "<span>$1</span>");
    
    // تبدیل آدرس به لینک در سایت اصلی
    text = text?.replace(
        
        /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g,
        '<a target="_blank" href="$1"><bdi dir="auto">$1</bdi></a>',
    );

    if (text && type == "twitter") {
        // تبدیل هشتگ به لینک در سایت اصلی
        text = twitterHashtag(text);
    }

    if (text && type == "instagram") {
        // تبدیل هشتگ به لینک در سایت اصلی

        text = text?.replace(
            /([#])+([\u0600-\u06FF\u202C\u064B\u064C\u064E-\u0652\u06F0-\u06F9\u0622\u0627\u0628\u067E\u062A-\u062C\u0686\u062D-\u0632\u0698\u0633-\u063A\u0641\u0642\u06A9\u06AF\u0644-\u0648\u06CC\u0660-\u0669\u200c\u2009_\u00a9\u00ae\u2000-\u3300\ud83c\ud000-\udfff\ud83d\ud000-\udfff\ud83e\ud000-\udfff0-9\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]+)/g,
            `<a target="_blank" href="${baseMentionAndHashtagUrl[type].hashtag}$2"><bdi dir="auto">#$2</bdi></a>`,
        );
    }

    // تبدیل منشن به لینک در سایت اصلی
    text = text?.replace(
        /(?:@)([a-zA-Z0-9\u200c_](?:(?:[a-zA-Z0-9\u200c_]|(?:\.(?!\.))){0,28}(?:[a-zA-Z0-9\u200c_]))?)/g,
        `<a target="_blank" href="${baseMentionAndHashtagUrl[type].mention}$1"><bdi dir="auto">@$1</bdi></a>`,
    );

    return text;
};

/* دریافت تصویر از CDN بک اند
 * @param {*} address
 * @returns
 */
export const getImageFromProxy = (address, noProxy) => {
    let url = null;
    try {
        url = `https://cdn.dataak.com/download?url=${window.btoa(address)}${noProxy ? "&no_proxy=1":""}`;
    } catch (error) {
        url = null;
    }
    return url;
};

/**
 * دریافت تصویر از کش بک اندی
 */
export const getImageFromCache = (_address, noProxy) => {
    // #TODO: فعلا چون چون بک بلیز وپراکسی های مارو ساپورت نمیکنه
    if (_address?.includes("backblazeb")) {
        return new Promise((resolve) => {
            resolve(_address);
        });
    }
    return new Promise((resolve) => {
        const address = getImageFromProxy(_address, noProxy);
        resolve(address);
    });
};
/**
 * دریافت تصویر از کش بک اندی
 */
 export const getImageAddressFromCache = (_address, noProxy) => {
    // #TODO: فعلا چون چون بک بلیز وپراکسی های مارو ساپورت نمیکنه
    if (_address?.includes("backblazeb")) {
        return _address;
    }
    const address = getImageFromProxy(_address, noProxy);
    return  address
 
};
export const  onImageError=(ev)  =>{
    ev.target.src = "/images/no_image.jpg";
}

/**
 * تبدیل آرایه به چندین آرایه
 */
export const chunkify = (a, n, balanced) => {
    if (n < 2) return [a];

    var len = a.length,
        out = [],
        i = 0,
        size;

    if (len % n === 0) {
        size = Math.floor(len / n);
        while (i < len) {
            out.push(a.slice(i, (i += size)));
        }
    } else if (balanced) {
        while (i < len) {
            size = Math.ceil((len - i) / n--);
            out.push(a.slice(i, (i += size)));
        }
    } else {
        n--;
        size = Math.floor(len / n);
        if (len % size === 0) size--;
        while (i < size * n) {
            out.push(a.slice(i, (i += size)));
        }
        out.push(a.slice(size * n));
    }

    return out;
};
